export const rv = (mobile?: string | number, desktop?: string | number): any => {
  return { xs: mobile, lg: desktop };
};
